// @ts-strict-ignore
import * as React from 'react';
import { useSelector } from 'react-redux';
import { RootState } from '../../reducers/reducers';
import { selectVCSIntegration } from '../../selectors/selectors';
import { StabilityInfo, StabilityIssue } from '../../types';
import StabilityIssueDrawer from '../stability/StabilityIssueDrawer';
import StabilityIssues from '../stability/StabilityIssues';
import { antGrey, runwayColors } from '../styles/globalStyles';
import { CollapsibleSection } from './CollapsibleSection';
import { nonFatalStabilityIssuesSupportedForIntegration } from '@/helpers';

interface StabilityIssuesContainerProps {
    appId: string;
    stabilityInfo: StabilityInfo;
    shouldHaveWhiteBackground?: boolean;
}

const StabilityIssuesContainer: React.FC<StabilityIssuesContainerProps> = (props: StabilityIssuesContainerProps) => {
    const { appId, stabilityInfo } = props;

    const [showDrawerForIssue, setShowDrawerForIssue] = React.useState<StabilityIssue>(null);

    const stabilityIntegrationId = stabilityInfo?.integrationId;
    const topNewIssues = stabilityInfo?.topNewStabilityIssues ?? [];
    const topIssues = stabilityInfo?.topStabilityIssues ?? [];
    const topNewIssuesNonFatal = stabilityInfo?.topNewStabilityIssuesNonFatal ?? [];
    const topIssuesNonFatal = stabilityInfo?.topStabilityIssuesNonFatal ?? [];
    const vcsIntegration = useSelector((state: RootState) => selectVCSIntegration(state, appId));

    return (
        <CollapsibleSection
            title="Stability issues"
            integrationType={stabilityIntegrationId}
            badge={topNewIssues?.length}
            shouldHaveWhiteBackground={props.shouldHaveWhiteBackground}
        >
            <div
                style={{
                    width: '100%',
                }}
            >
                <StabilityIssues
                    topNewStabilityIssues={topNewIssues}
                    topStabilityIssues={topIssues}
                    topNewStabilityIssuesNonFatal={topNewIssuesNonFatal}
                    topStabilityIssuesNonFatal={topIssuesNonFatal}
                    backgroundColor={props.shouldHaveWhiteBackground ? runwayColors.white : antGrey.grey2}
                    shouldShowNonFatals={nonFatalStabilityIssuesSupportedForIntegration(stabilityIntegrationId)}
                    onShowDrawerForIssue={(issue) => setShowDrawerForIssue(issue)}
                />
                <StabilityIssueDrawer
                    open={!!showDrawerForIssue}
                    integrationId={stabilityIntegrationId}
                    issue={showDrawerForIssue}
                    onClose={() => setShowDrawerForIssue(null)}
                    vcsId={vcsIntegration?.id}
                    appId={appId}
                />
            </div>
        </CollapsibleSection>
    );
};

export default StabilityIssuesContainer;
